import { trackClickAndReserveEvent } from '../tracking/trackingLayer';

const templateElement = document.getElementById('hva-link-template');

export default {
  template: templateElement ? templateElement.innerHTML : '',
  props: {
    articleId: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const openLayer = () => {
      document.dispatchEvent(new CustomEvent('ents:hva-modal:open', { detail: { articleId: props.articleId } }));
      trackClickAndReserveEvent();
    };

    return { openLayer };
  },
};
